import { get } from 'lodash';
import request from '@/utils/request';

// 产品接口 获取积分详情
export function getPointDetailDXP(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/points/accounts/info', {
    method: 'GET',
    params,
  });
}

// 获取商品列表目录
export function getCatgctListDXP(queryParam) {
  const path = queryParam
    ? `/promotion-rest-boot/dxp/loyalty/v1/points/offer/${queryParam || ''}/catgs`
    : '/promotion-rest-boot/dxp/loyalty/v1/points/offer/catgs';
  return request(path, {
    method: 'GET',
  });
}

// 获取商品详情产品接口
export function getProductDetailDXP(params) {
  return request(`/promotion-rest-boot/dxp/loyalty/v1/points/offer/${params.spuNbr}`, {
    method: 'GET',
    params: {
      pointAcctTypeCode: params.pointAcctTypeCode,
    },
  });
}

// 产品化 搜索接口
export function getProductSearchDXP(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/points/market-offers', {
    method: 'POST',
    data: params,
  });
}

// // 转赠积分
// export function getPointTransfer(params) {
//   return request('/ecare/webs/point/transfer', {
//     method: 'POST',
//     data: get(params, 'data'),
//     // headers: { 'Auth-Token': get(params, 'Auth-Token') },
//     headers: { 'Auth-Token': token },
//   });
// }

// 发送验证码
export function sendSMSCode(params) {
  return request('/promotion-rest-boot/promotion/notification/sendOtp', {
    data: get(params, 'data'),
    method: 'POST',
    // headers: { 'Auth-Token': get(params, 'Auth-Token') },
  });
}

// 兑换积分 Redeem points queryExchange
export function redeemPointsDXP(data) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/points/offer/exchange', {
    method: 'POST',
    data,
  });
}

// 查询订单列表
export function qryOrderListDXP(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/points/order/history', {
    method: 'GET',
    params,
  });
}

// 积分历史
export function queryChangeHisDXP(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/points/history', {
    method: 'GET',
    params,
  });
}

export function getDealerPageInfoDXP(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/points/mall/page-config', {
    method: 'GET',
    data: params,
    // headers: { 'Auth-Token': get(params, 'token') },
  });
}

// 积分商城首页组件查询
export function getHomeContentDXP(params) {
  return request('/promotion-rest-boot/dxp/page-builder/v1/pages', {
    method: 'GET',
    params,
  });
}

// 查询租户下所有文章
export function qryFaqList(params) {
  return request('/promotion-rest-boot/promotion/faq/wiki/list', {
    method: 'GET',
    params,
  });
}
// 获取预制的差评常用原因列表，代理商
export function getNegativeComments(params) {
  return request('/promotion-rest-boot/promotion/faq/negative/comments', {
    method: 'POST',
    data: params,
  });
}

// 评价接口
export function sendWikiComment(params) {
  return request('/promotion-rest-boot/promotion/faq/wiki/comment', {
    method: 'POST',
    data: params,
  });
}
export function queryVoucherHistoryListDXP(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/coupon-instance/history', {
    method: 'GET',
    params,
  });
}

export function queryPointHistoryDXP(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/points/month-change-his', {
    method: 'GET',
    params,
  });
}

export function queryExchangeRule(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/points/exchange-rule/rules', {
    method: 'GET',
    params,
  });
}

export function queryLedgerBalance(acctResCode) {
  return request(`/promotion-rest-boot/dxp/loyalty/v1/points/${acctResCode}/account-balance`, {
    method: 'GET',
  });
}

export function exchangePoints(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/points/exchange-rule/exchange', {
    method: 'POST',
    data: params,
  });
}
export function conversionList(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/points/accounts/redeem-rules', {
    method: 'GET',
    params,
  });
}
export function conversionPoint(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/points/accounts/redemption', {
    method: 'POST',
    data: params,
  });
}
export function transferPointList(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/points/account-types', {
    method: 'GET',
    params,
  });
}

// /dxp/loyalty/v1/coupon-instance/detail
export function queryCouponDetail(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/coupon-instance/detail', {
    method: 'GET',
    params,
  });
}

// /dxp/product-catalog/v1/offers/list
export function queryCouponOfferList(data) {
  return request('/promotion-rest-boot/dxp/product-catalog/v1/offers/list', {
    method: 'POST',
    data,
  });
}

export function redeemCoupon(data) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/coupon-instance/redemption', {
    method: 'POST',
    data,
  });
}

export function claimCoupon(data) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/coupon-instance/claim', {
    method: 'POST',
    data,
  });
}
